import React from 'react';
import { Container } from 'react-bootstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';

import 'react-big-calendar/lib/sass/styles.scss';

import './SchedulePage.css';

import events from './Events/Events';

const localizer = momentLocalizer(moment);

const SchedulePage = () => {
  return (
    <div className="schedule-page">
      <Container>
        {/* Page Title */}
        <h2>
          <FontAwesomeIcon className="page-title-icon" icon={faCalendarAlt} />
          <span className="page-title">Schedule</span>
        </h2>
        {/* End Page Title */}
        {/* Page Content */}
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
        />
        {/* End Page Content */}
       </Container>
    </div>
  );
};

export default SchedulePage;